module.exports = __webpack_public_path__ + "media/images/pictograms/pic2-249f19f3db231996739fa95f1f655fab.png";